export default {
    bloglist: {
        en: [
            {
                title: 'Guide to Resolving GB WhatsApp Installation Issues',
                poster: require('@/assets/blog-1.webp'),
                desc: "GBWhatsApp not installing? Fix \"App Not Installed\", \"Parse Error\", Play Protect block, and version conflicts with this complete guide.",
                name: 'en-blog1',
                url: '/resolving-gbwhatsapp-installation-issues/',
                date: "2025-11-21",
            },
            {
                title: 'Methods to Unread Messages in GB WhatsApp',
                poster: require('@/assets/blog-2.webp'),
                desc: "Explore effective methods to unread messages in GB WhatsApp, including viewing, marking, archiving, and privacy features for efficiency.",
                name: 'en-unread-messages-in-gbwhatsapp',
                url: '/unread-messages-in-gbwhatsapp/',
                date: "2026-01-07",
            },
            {
                title: 'Should I Stop Using GB WhatsApp in 2026?',
                poster: require('@/assets/blog-3.webp'),
                desc: "In 2026, should you keep using GB WhatsApp? Learn the real risks, ban signals, security concerns, and safer ways to manage your account if you choose to continue.",
                name: 'en-blog3',
                url: '/should-i-stop-using-gbwhatsapp-in-2026/',
                date: "2026-04-29",
            },
            {
                title: 'Why Some GB WhatsApp APK Files Are Fake',
                poster: require('@/assets/blog-3.webp'),
                desc: "Fake GB WhatsApp APKs are common in 2026. This guide explains how tampered files spread, what to check before installing, and how to spot suspicious builds.",
                name: 'en-blog4',
                url: '/why-some-gbwhatsapp-apk-files-are-fake/',
                date: "2026-04-29",
            },
            {
                title: 'What Happens to Your Data If GB WhatsApp Gets Banned',
                poster: require('@/assets/blog-3.webp'),
                desc: "A ban can feel sudden. Here’s what typically happens to your chat history, media, notifications, and backups when GB WhatsApp is blocked—and what you can do beforehand.",
                name: 'en-blog5',
                url: '/what-happens-to-your-data-if-gb-whatsapp-gets-banned/',
                date: "2026-04-29",
            },
            {
                title: 'How to Read Deleted Messages in GB WhatsApp',
                poster: require('@/assets/blog-1.webp'),
                desc: "Someone deleted a message before you could read it? See how GB WhatsApp's Anti-Delete feature works and how to turn it on.",
                name: 'en-blog6',
                url: '/how-to-read-messages-in-gbwhatsapp/',
                date: "2026-09-11",
            },
            {
                title: 'How to Schedule Messages in GB WhatsApp',
                poster: require('@/assets/blog-2.webp'),
                desc: "Need to send a WhatsApp message later? Learn how to schedule messages in GB WhatsApp and fix common scheduler problems.",
                name: 'en-blog7',
                url: '/how-to-schedule-messages-in-gbwhatsapp/',
                date: "2026-09-11",
            },
            // {
            //     title: 'How to Change Fonts on GBWhatsApp Easily',
            //     poster: require('@/assets/blog-1.webp'),
            //     desc: "GBWhatsApp is one of the most popular WhatsApp mods in 2025, loved for its extra features and customization options. Among its most sought-after features is the ability to change fonts in GBWhatsApp — giving your chats a fresh, stylish look.",
            //     name: 'en-blog1',
            //     url: 'https://wave-gb.org/how-change-fonts-on-gbwhatsapp/',
            //     date:"2025-08-15",
            // }
        ],
    }
    
}
